import * as React from 'react';
import { Users } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { useMultiCanvasViewStore } from '../../../stores/multiCanvasViewStore';
import { POSITION_STAFFING_PROJECTION_KIND } from './PositionStaffingWorkbenchPane';

/**
 * Reopen affordance for the staffing workbench.
 *
 * The workbench auto-opens once per position chart. Closing it used to be
 * terminal for the session because nothing else mounted the projection, so the
 * only recovery was reopening the diagram. This renders only while the pane is
 * closed and puts the user back in control.
 */
export const PositionStaffingWorkbenchToggle: React.FC = () => {
  const activeProjection = useMultiCanvasViewStore((state) => state.activeProjection);
  const openProjection = useMultiCanvasViewStore((state) => state.openProjection);
  const setLayout = useMultiCanvasViewStore((state) => state.setLayout);

  if (activeProjection?.kind === POSITION_STAFFING_PROJECTION_KIND) return null;

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="absolute bottom-20 right-6 z-50 h-9 gap-2 rounded-full bg-background shadow-lg"
      data-testid="tid.orgchart.staffingWorkbench.reopen"
      onClick={() => {
        openProjection(POSITION_STAFFING_PROJECTION_KIND);
        setLayout('split_75_25');
      }}
    >
      <Users className="size-4" />
      Staffing workbench
    </Button>
  );
};
